import React, {useCallback, useEffect, useState} from 'react';
import {Link, useLocation, useNavigate, useParams} from 'react-router-dom';
import TitleMain from "../../components/Title/TitleMain";
import {useModal} from "../../contexts/ModalContext";
import TitleSecondary from "../../components/Title/TitleSecondary";
import {useUser} from "../../contexts/UserContext";
import {
    getStatsMainPage, getStatsTabSeancesPage,
} from "../../services/StatsService";
import SeancesStatsTable from "../../components/Seance/SeancesStatsTable";
import styles from "./Statistiques.module.css";
import UsersStatsTable from "../../components/Seance/UsersStatsTable";
import {exportToCsv} from "../../services/FileService";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faDownload, faExternalLink, faFilter} from "@fortawesome/free-solid-svg-icons";
import FilterHamburgerCustom from "../../components/Filter/FilterHamburgerCustom";
import Routing from "../../services/routing";
import styles_filter from "../../components/Filter/Filter.module.css";
import SearchEntreprise from "../../components/Search/SearchEntreprise";
import styles_field from "../../components/Field/Field.module.css";
import {ReactComponent as AnnulerIcon} from "../../icons/annuler.svg";
import {updateFilterUri} from "../../services/FilterService";
import {DatesFilter} from "../../components/Filter/DatesFilter";
import {SelectFilter} from "../../components/Filter/SelectFilter";
import AxiosConfig from "../../services/AxiosConfig";
import RangeFilter from "../../components/Filter/RangeFilter";
import PaginationBar from "../../components/Pagination/PaginationBar";
import DateService from "../../services/DateService";


function TabSeancesStatsPage() {
    const { user } = useUser();
    const { showModal } = useModal();
    const [seances, setSeances] = useState([]);
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const navigate = useNavigate();
    const [activiteTypes, setActiviteTypes] = useState([]);
    const [filterDateDebut, setFilterDateDebut] = useState(params.get('filter_date') ? params.get('filter_date').split(',')[0] : '');
    const [filterDateFin, setFilterDateFin] = useState(params.get('filter_date') ? params.get('filter_date').split(',')[1] : '');
    const [page, setPage] = useState(params.get('page') || 1);
    const [totalPage, setTotalPage] = useState(null);
    const [totalResult, setTotalResult] = useState(null);
    const [satisfactionVal, setSatisfactionVal] = useState(params.get("filter_satisfaction") ? (decodeURI(params.get("filter_satisfaction")) || "0,100").split(",") || [0,100] : [0,100]);
    let filterDates = "";

    const handleSuccess = useCallback((message = "Statistiques récupérées") => {
        showModal('success', { children: message, timeout: 1500 });
    }, [showModal]);

    const handleError = useCallback((message = "Une erreur est survenue") => {
        showModal('error', { children: message, timeout: 1500 });
    }, [showModal]);

    const removeFilter = (e) => {
        const key = e.currentTarget.querySelector('.filter_key').textContent;
        params.delete(`filter_${key}`);
        navigate(`?${params.toString()}`);
    }

    const updateFilter = (filterKey, filterValue, resetFilter = false) => {
        const params = new URLSearchParams(location.search);

        updateFilterUri(params, filterKey, filterValue, resetFilter);

        navigate(`${location.pathname}?${params.toString()}`, { replace: true });
    };

    const handleSeanceSelectChange = (event) => {
        const selectedValue = event.target.value;
        updateFilter('filter_seance', selectedValue, true);
    };

    const handleActiviteTypeSelectChange = (event) => {
        const selectedValue = event.target.value;
        updateFilter('filter_type', selectedValue, true);
    };

    const applyDateConfirmationFilter = (startDate, endDate) => {
        setFilterDateDebut(startDate);
        setFilterDateFin(endDate);

        const value = `${startDate},${endDate}`;

        updateFilter('filter_date', value, true);

        // const urlParams = new URLSearchParams(window.location.search);
        // if (startDate && endDate) {
        //     urlParams.set("filter_date", value);
        // } else {
        //     urlParams.delete("filter_date");
        // }

        // window.history.replaceState(
        //     null,
        //     "",
        //     `${window.location.pathname}?${urlParams.toString()}`
        // );
    };

    const onChangeSatisfaction = async (value) => {
        if (!value[0] && value[1]) {
            value[0] = 0;
            setSatisfactionVal(value);
        }

        if (value[0] && !value[1]) {
            value[1] = 100;
            setSatisfactionVal(value);
        }
        updateFilter('filter_satisfaction', value, true);
    }

    const seancesFilterOptions = [
        { label: "Toutes", value: "toutes" },
        { label: "Disponibles à inscriptions", value: "dispo" },
        { label: "Passées", value: "passees" },
    ];

    const filterChildren = (
        <div>
            <TitleSecondary text={"Filtres"}/>
            <div className={styles_filter.filtersRemoveBar}>
                {Array.from(params.entries())
                    .filter(([key, value]) => key.startsWith('filter_'))
                    .map(([key, value]) => {
                        let strValue = value;
                        if (key === "filter_type") {
                            strValue = activiteTypes.find(at => parseInt(at.value) === parseInt(value))?.label;
                        }

                        if (key === "filter_date") {
                            const date1 = value.split(',')[0];
                            const date2 = value.split(',')[1];
                            strValue = ` ${DateService.formatFrenchDateWithoutTime(date1)} au ${DateService.formatFrenchDateWithoutTime(date2)}`;
                            filterDates = strValue;
                        }

                        return (
                            <button key={key} className={styles_filter.btnFilterRemove} onClick={removeFilter}>
                                <AnnulerIcon/>
                                <span className={"filter_key"}>{key.replace('filter_', '')}</span> : {strValue}
                            </button>
                        );
                    })
                }
            </div>

            <div style={{display: "flex", flexDirection: "column", gap: "16px"}}>
                <SelectFilter label={"Type d'activité"} selectId={"selectTypeActivite"} options={activiteTypes} onChangeSelect={handleActiviteTypeSelectChange} defaultValue={parseInt(params.get("filter_type"))}/>
                <SelectFilter label={"Séances"} selectId={"seanceFilter"} options={seancesFilterOptions} onChangeSelect={handleSeanceSelectChange} defaultValue={params.get("filter_seance")}/>
                <DatesFilter startValue={filterDateDebut} endValue={filterDateFin} onChange={applyDateConfirmationFilter}/>
                <RangeFilter
                    label={"Satisfaction:"}
                    onChange={onChangeSatisfaction}
                    defaultValue={satisfactionVal}
                />
            </div>
        </div>
    );

    const fetchData = async () => {
        const rez = await getStatsTabSeancesPage(location.search);
        if (rez.success === true || rez.success === "true") {
            if (rez.data) {
                setSeances(rez.data);
                setTotalPage(rez.totalPages);
                setTotalResult(rez.totalResult);
            } else {
                handleError("Pas de données pour les activités");
            }
        } else {
            handleError(rez.message);
        }
    }

    const fetchActiviteTypes = async () => {
        try {
            const response = await AxiosConfig.get("/activites/types");

            const rez = response.data;

            if (rez.success === true || rez.success === "true") {
                if (rez.types) {
                    setActiviteTypes(rez.types);
                } else {
                    handleError("Pas de données pour les activités");
                }
            } else {
                handleError(rez.message);
            }
        } catch (error) {
            console.error('error: ', error);
            throw error;
        }
    }

    useEffect(() => {
        if (!user) return;
        fetchData();
        fetchActiviteTypes();
    }, [user, location.search]);

    useEffect(() => {
        if (page) {
            params.set('page', page);
            navigate(`${location.pathname}?${params.toString()}`);
        }
    }, [page]);

    return (
        <div className="content_tab">
            <TitleMain text={"STATISTIQUES SEANCES"}/>

            <Link style={{ margin: "20px"}} to={Routing.routes.statsActiviteTypes}>Statistiques des Activités <FontAwesomeIcon icon={faExternalLink}/></Link>

            <div className={styles.mobileMessage}>
                Pour une meilleure expérience, veuillez consulter ce tableau sur un ordinateur de bureau ou un écran plus grand.
            </div>

            <FilterHamburgerCustom onReinirFilters={() => navigate(`${location.pathname}`)}
                                   children={filterChildren}/>

            <div className={styles.tableau}>
                { filterDates &&
                    <span style={{
                        fontSize: "14px",
                        color: "#3c3c3c",
                        fontStyle: "italic",
                    }}>Données du { filterDates }</span>
                }

                <SeancesStatsTable seances={seances} />

                <div style={{display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center"}}>
                    <PaginationBar page={page} totalPage={totalPage} setPage={setPage} totalResult={totalResult}/>
                </div>
            </div>

        </div>
    )
}

export default TabSeancesStatsPage;
